import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawAddTextSetIcon from "./RawAddTextSetIcon.svg.jsx";

const AddTextSetIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawAddTextSetIcon} {...props} />;
});

export default AddTextSetIcon;
